import React, { ReactNode } from 'react';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ModalContainer, ModalContent } from './styles';

interface ReusableModalProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  style?: React.CSSProperties;
}

const ReusableModal: React.FC<ReusableModalProps> = ({ open, onClose, children, style }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="reusable-modal"
      aria-describedby="reusable-modal-content"
    >
      <ModalContent style={style}>
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <ModalContainer>
          {children}
        </ModalContainer>
      </ModalContent>
    </Modal>
  );
};

export default ReusableModal;
